import { makeStyles } from '@mui/styles';

export const useStylesSecondaryButton = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 46,
    marginBottom: 16,
    backgroundColor: theme.colors.dark.steelBlue,
    color: theme.colors.light.freshPowder,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
    },
  },
}));

export const useStylesSecondaryIconButton = makeStyles(theme => ({
  root: {
    height: 46,
    marginBottom: 16,
    marginRight: 15,
    backgroundColor: theme.colors.dark.steelBlue,
    color: theme.colors.light.freshPowder,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
    },
  },
}));
